import { generatePath } from 'react-router-dom'

interface RedirectTarget {
  pathname: string
  search: string
  hash: string
}

/**
 * Builds a redirect target that carries the current query string and hash across.
 *
 * Until sign-in lands (ENG-471) the flow editor is authenticated by `accessToken` /
 * `refreshToken` query params, so a redirect that drops the search string silently
 * unauthenticates it. Always redirect through this helper, never with a bare path.
 */
export const buildRedirectTo = (
  pattern: string,
  params: Record<string, string | undefined>,
  search: string,
  hash: string,
): RedirectTarget => {
  return {
    pathname: generatePath(pattern, params),
    search,
    hash,
  }
}
